// ============================================
// FIGHTWATCH — fw-home.js
// Section homepage premium — animations & interactions
// Scopé à .fw-home, aucune dépendance au reste du thème
// ============================================

document.addEventListener('DOMContentLoaded', () => {

  const fwHome = document.querySelector('.fw-home');
  if (!fwHome) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Hero entrance --- */
  const hero = fwHome.querySelector('.fw-hero');
  if (hero) {
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('fw-is-ready'), 80);
    });
  }

  /* --- Generic scroll reveal (titles, cards, banner text) --- */
  const revealEls = fwHome.querySelectorAll('.fw-reveal-up');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fw-is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => revealObserver.observe(el));
  } else {
    // fallback: no IntersectionObserver support — just show everything
    revealEls.forEach(el => el.classList.add('fw-is-visible'));
  }

  /* --- Banner ring line reveal --- */
  const banner = fwHome.querySelector('.fw-banner');
  if (banner && 'IntersectionObserver' in window) {
    const bannerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          banner.classList.add('fw-is-visible');
          bannerObserver.unobserve(banner);
        }
      });
    }, { threshold: 0.3 });
    bannerObserver.observe(banner);
  }

  /* --- Animated stat counters --- */
  const stats = fwHome.querySelectorAll('.fw-stat__num');
  const animateCount = (el) => {
    const target = parseFloat(el.dataset.count);
    if (Number.isNaN(target)) return;
    const decimals = parseInt(el.dataset.decimal || '0', 10);
    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      const value = target * eased;
      el.textContent = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toLocaleString('fr-FR');
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = decimals > 0 ? target.toFixed(decimals) : Math.round(target).toLocaleString('fr-FR');
      }
    };
    requestAnimationFrame(tick);
  };

  if (stats.length && 'IntersectionObserver' in window) {
    const statsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });
    stats.forEach(el => statsObserver.observe(el));
  }

  /* --- Smooth anchor scroll for in-section links (#fw-collections, #fw-produits...) --- */
  fwHome.querySelectorAll('a[href^="#fw-"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href');
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        const themeHeader = document.querySelector('header.header, .shopify-section-header, #shopify-section-header');
        const offset = (themeHeader ? themeHeader.offsetHeight : 0) + 16;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* --- Cinematic scroll parallax (hero + lifestyle banner backgrounds) --- */
  if (!reduceMotion) {
    const parallaxTargets = [
      { section: fwHome.querySelector('#fwHero'), img: fwHome.querySelector('#fwHeroImg'), strength: 0.18 },
      { section: fwHome.querySelector('#fwLifestyle'), img: fwHome.querySelector('#fwLifestyleImg'), strength: 0.15 }
    ].filter(t => t.section && t.img);

    if (parallaxTargets.length) {
      let ticking = false;

      const updateParallax = () => {
        const viewportH = window.innerHeight;
        parallaxTargets.forEach(({ section, img, strength }) => {
          const rect = section.getBoundingClientRect();
          // Only compute while the section is anywhere near the viewport
          if (rect.bottom < -200 || rect.top > viewportH + 200) return;
          const centerOffset = rect.top + rect.height / 2 - viewportH / 2;
          const translate = centerOffset * strength * -1;
          img.style.transform = `translate3d(0, ${translate.toFixed(1)}px, 0)`;
        });
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(updateParallax);
        }
      };

      updateParallax();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }

});
